import React, {
  FC,
  ReactElement,
  useCallback,
  useEffect,
  useState,
} from 'react';
import { Image, Layer } from 'grommet';

const sequence = [`KeyS`, `KeyU`, `KeyM`, `KeyO`];

export const Sumo: FC = (): ReactElement | null => {
  const [show, setShow] = useState(false);
  const [keys, setKeys] = useState<string[]>([]);
  const captureKey = useCallback(
    (event: any) => setKeys((prevState) => [...prevState, event.code]),
    [],
  );

  useEffect(() => {
    document.addEventListener(`keydown`, captureKey);
    return () => document.removeEventListener(`keydown`, captureKey);
  }, [captureKey]);

  useEffect(() => {
    if (keys.length < sequence.length) return;
    if (keys.slice(-sequence.length).toString() === sequence.toString()) {
      setShow(true);
      setKeys([]);
    }
    if (keys.length > 12) setKeys([]);
  }, [keys]);

  if (show)
    return (
      <Layer background="transparent" full onClick={() => setShow(false)}>
        <Image
          alignSelf="center"
          fit="contain"
          src="/img/sumo.webp"
          alt="sumo"
        />
      </Layer>
    );
  return null;
};
